import React from 'react';

const tocItems = [
    { id: 'info-collect', text: '1. INFORMATION WE COLLECT' },
    { id: 'info-use', text: '2. HOW WE USE YOUR INFORMATION' },
    { id: 'info-share', text: '3. INFORMATION SHARING' },
    { id: 'data-security', text: '4. DATA SECURITY' },
    { id: 'data-retention', text: '5. DATA RETENTION' },
    { id: 'your-rights', text: '6. YOUR RIGHTS' },
    { id: 'children', text: "7. CHILDREN'S PRIVACY" },
    { id: 'privacy-updates', text: '8. UPDATES TO THIS PRIVACY POLICY' },
    { id: 'contact', text: '9. CONTACT US' }
];

const PrivacyPolicy = () => {
    return (
        <div className="max-w-5xl mx-auto px-4 py-6">
            <style>
                {`
                [data-custom-class='body'], [data-custom-class='body'] * {
                    background: transparent !important;
                }
                [data-custom-class='title'], [data-custom-class='title'] * {
                    font-family: Arial !important;
                    font-size: 26px !important;
                    color: #000000 !important;
                }
                [data-custom-class='subtitle'], [data-custom-class='subtitle'] * {
                    font-family: Arial !important;
                    color: #595959 !important;
                    font-size: 14px !important;
                }
                [data-custom-class='heading_1'], [data-custom-class='heading_1'] * {
                    font-family: Arial !important;
                    font-size: 19px !important;
                    color: #000000 !important;
                }
                [data-custom-class='heading_2'], [data-custom-class='heading_2'] * {
                    font-family: Arial !important;
                    font-size: 17px !important;
                    color: #000000 !important;
                }
                [data-custom-class='body_text'], [data-custom-class='body_text'] * {
                    color: #595959 !important;
                    font-size: 14px !important;
                    font-family: Arial !important;
                }
                [data-custom-class='link'], [data-custom-class='link'] * {
                    color: #3030F1 !important;
                    font-size: 14px !important;
                    font-family: Arial !important;
                    word-break: break-word !important;
                }
                ul {
                    list-style-type: square;
                }
                ul > li > ul {
                    list-style-type: circle;
                }
                ul > li > ul > li > ul {
                    list-style-type: square;
                }
                ol li {
                    font-family: Arial ;
                }
                `}
            </style>

            <div className="bg-white rounded-xl border border-gray-200 p-8 shadow-sm">
                <span className="block mx-auto mb-10 w-44 h-10 rounded bg-gray-100 border border-gray-200 text-center leading-10 font-semibold text-gray-700">
                    OakHR
                </span>

                <div data-custom-class="body">
                    <div data-custom-class="title">
                        <h1>PRIVACY POLICY</h1>
                    </div>
                    <div data-custom-class="subtitle">
                        <strong>Last updated</strong> <strong>February 01, 2026</strong>
                    </div>

                    <div className="mt-8" data-custom-class="body_text">
                        <strong>Konav Technologies Private Limited</strong> ("<strong>we</strong>," <strong>"us</strong>," or <strong>"our</strong>") operates the OakHR platform (<strong>"oak-hr.com"</strong> and the <strong>"OakHRMobile"</strong> application). We respect your privacy and are committed to protecting your personal data. This privacy policy will inform you as to how we look after your personal data when you visit our website and mobile application (regardless of where you visit it from) and tell you about your privacy rights and how the law protects you.
                    </div>
                    <div className="mt-4" data-custom-class="body_text">
                        Please read this privacy policy carefully. It contains important information about your privacy rights and obligations.
                    </div>

                    <div className="mt-8" data-custom-class="heading_1">
                        <h2>TABLE OF CONTENTS</h2>
                    </div>
                    <div className="mt-4 space-y-1">
                        {tocItems.map((item) => (
                            <div key={item.id}>
                                <a href={`#${item.id}`} data-custom-class="link">
                                    {item.text}
                                </a>
                            </div>
                        ))}
                    </div>

                    {/* SECTION 1 */}
                    <div className="mt-10" data-custom-class="heading_1">
                        <h2 id="info-collect">1. INFORMATION WE COLLECT</h2>
                    </div>
                    <p className="mt-3" data-custom-class="body_text">
                        We collect personal information that you voluntarily provide to us when you register for the Services, express an interest in obtaining information about us or our products and Services, when you participate in activities on the Services, or otherwise when you contact us.
                    </p>

                    <div className="mt-4" data-custom-class="heading_2">
                        <h3>Personal Information Provided by You</h3>
                    </div>
                    <p className="mt-3" data-custom-class="body_text">
                        We collect personal information that you voluntarily provide to us when you express an interest in obtaining information about us or our products and Services, when you participate in activities on the Services, or otherwise when you contact us.
                    </p>
                    <ul className="mt-2 list-disc pl-6" data-custom-class="body_text">
                        <li><strong>Account Information:</strong> Name, email address, phone number, password, and security question answers</li>
                        <li><strong>Employee Information:</strong> Employee ID, profile details, job title, department, and employment history</li>
                        <li><strong>Financial Information:</strong> Bank account information for payroll, salary details, and compensation information</li>
                        <li><strong>Tax Information:</strong> Tax identification numbers (PAN, Aadhaar), and other tax-related documents</li>
                        <li><strong>Personal Identifiers:</strong> Date of birth, gender, marital status, and emergency contact information</li>
                    </ul>

                    <div className="mt-4" data-custom-class="heading_2">
                        <h3>Employment Data Automatically Collected</h3>
                    </div>
                    <p className="mt-3" data-custom-class="body_text">
                        Our Services automatically collect certain employment-related information when you perform actions within the platform:
                    </p>
                    <ul className="mt-2 list-disc pl-6" data-custom-class="body_text">
                        <li>Attendance records, including clock-in/clock-out times</li>
                        <li>Leave requests and approval history</li>
                        <li>Performance reviews, ratings, and feedback</li>
                        <li>Payroll processing records and salary slips</li>
                        <li>Expense claims and reimbursement records</li>
                    </ul>

                    <div className="mt-4" data-custom-class="heading_2">
                        <h3>Usage Data</h3>
                    </div>
                    <p className="mt-3" data-custom-class="body_text">
                        We may also collect information about how you access and use the Services:
                    </p>
                    <ul className="mt-2 list-disc pl-6" data-custom-class="body_text">
                        <li>Device information, including browser type, operating system, and IP address</li>
                        <li>Login timestamps and session duration</li>
                        <li>Features accessed and actions performed within the Services</li>
                        <li>Pages viewed and time spent on each page</li>
                    </ul>

                    {/* SECTION 2 */}
                    <div className="mt-8" data-custom-class="heading_1">
                        <h2 id="info-use">2. HOW WE USE YOUR INFORMATION</h2>
                    </div>
                    <p className="mt-3" data-custom-class="body_text">
                        We use the information we collect to provide, maintain, and improve our Services, and to process your employment-related activities. The purposes for which we use personal information include:
                    </p>
                    <ul className="mt-2 list-disc pl-6" data-custom-class="body_text">
                        <li><strong>Service Delivery:</strong> To process payroll, manage attendance, and maintain employee records</li>
                        <li><strong>Authentication:</strong> To verify your identity and prevent unauthorized access</li>
                        <li><strong>Communication:</strong> To send you notifications, updates, and important information</li>
                        <li><strong>Analytics:</strong> To analyze usage patterns and improve our Services</li>
                        <li><strong>Security:</strong> To detect, prevent, and address technical issues and fraudulent activity</li>
                        <li><strong>Compliance:</strong> To comply with legal obligations and industry regulations</li>
                    </ul>

                    {/* SECTION 3 */}
                    <div className="mt-8" data-custom-class="heading_1">
                        <h2 id="info-share">3. INFORMATION SHARING</h2>
                    </div>
                    <p className="mt-3" data-custom-class="body_text">
                        We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.
                    </p>

                    <div className="mt-4" data-custom-class="heading_2">
                        <h3>We Never Sell Your Personal Information</h3>
                    </div>
                    <p className="mt-3" data-custom-class="body_text">
                        <strong>We do not sell your personal information to anyone.</strong> Your data is never shared with advertisers, data brokers, or sold for marketing purposes.
                    </p>

                    <div className="mt-4" data-custom-class="heading_2">
                        <h3>Limited Information Sharing</h3>
                    </div>
                    <p className="mt-3" data-custom-class="body_text">
                        We may share your personal information only in the following circumstances:
                    </p>
                    <ul className="mt-2 list-disc pl-6" data-custom-class="body_text">
                        <li><strong>With Your Consent:</strong> We may share your information when you explicitly authorize us to do so</li>
                        <li><strong>Service Providers:</strong> With trusted third parties who assist us in operating our Services</li>
                        <li><strong>Legal Requirements:</strong> To comply with legal obligations, court orders, or government requests</li>
                        <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets</li>
                        <li><strong>Affiliates:</strong> With our corporate affiliates, subject to strict confidentiality obligations</li>
                        <li><strong>Protection of Rights:</strong> To protect our rights, property, or safety, or that of our users</li>
                    </ul>

                    {/* SECTION 4 */}
                    <div className="mt-8" data-custom-class="heading_1">
                        <h2 id="data-security">4. DATA SECURITY</h2>
                    </div>
                    <p className="mt-3" data-custom-class="body_text">
                        We have implemented appropriate technical and organizational security measures designed to protect the security of any personal information we process. However, despite our efforts, no method of transmission over the Internet, or method of electronic storage, is 100% secure.
                    </p>

                    <div className="mt-4" data-custom-class="heading_2">
                        <h3>Encryption</h3>
                    </div>
                    <ul className="mt-2 list-disc pl-6" data-custom-class="body_text">
                        <li>All data is encrypted in transit using TLS 1.3 or higher</li>
                        <li>Data at rest is encrypted using AES-256 encryption</li>
                        <li>Passwords are hashed using bcrypt with salt</li>
                        <li>Sensitive data is encrypted using industry-standard algorithms</li>
                    </ul>

                    <div className="mt-4" data-custom-class="heading_2">
                        <h3>Access Controls</h3>
                    </div>
                    <ul className="mt-2 list-disc pl-6" data-custom-class="body_text">
                        <li>Role-based access control (RBAC) restricts data access to authorized personnel</li>
                        <li>Multi-factor authentication (MFA) for all administrative accounts</li>
                        <li>Regular security audits and penetration testing</li>
                        <li>Employee background verification and confidentiality agreements</li>
                    </ul>

                    <div className="mt-4" data-custom-class="heading_2">
                        <h3>Infrastructure Security</h3>
                    </div>
                    <ul className="mt-2 list-disc pl-6" data-custom-class="body_text">
                        <li>Hardened cloud infrastructure with firewalls and intrusion detection</li>
                        <li>Regular automated backups with disaster recovery procedures</li>
                        <li>24/7 security monitoring and incident response</li>
                        <li>Compliance with ISO 27001 information security standards</li>
                    </ul>

                    {/* SECTION 5 */}
                    <div className="mt-8" data-custom-class="heading_1">
                        <h2 id="data-retention">5. DATA RETENTION</h2>
                    </div>
                    <p className="mt-3" data-custom-class="body_text">
                        We retain your personal information for as long as necessary to provide our Services and fulfill the purposes outlined in this privacy policy. Additionally, we will retain your data as required by applicable law, including for tax, accounting, and legal obligations.
                    </p>
                    <ul className="mt-2 list-disc pl-6" data-custom-class="body_text">
                        <li>Employment records are retained for the duration of employment plus the legally required period</li>
                        <li>Payroll records are retained for 7 years as per tax regulations</li>
                        <li>Account activity logs are retained for up to 2 years</li>
                        <li>Backup data is retained according to our disaster recovery policy</li>
                    </ul>

                    {/* SECTION 6 */}
                    <div className="mt-8" data-custom-class="heading_1">
                        <h2 id="your-rights">6. YOUR RIGHTS</h2>
                    </div>
                    <p className="mt-3" data-custom-class="body_text">
                        Under applicable data protection laws, you have the following rights regarding your personal information:
                    </p>

                    <div className="mt-4" data-custom-class="heading_2">
                        <h3>Access Rights</h3>
                    </div>
                    <ul className="mt-2 list-disc pl-6" data-custom-class="body_text">
                        <li>Request a copy of your personal data we hold</li>
                        <li>Know the categories of personal information we process</li>
                        <li>Know the purposes for which we use your information</li>
                    </ul>

                    <div className="mt-4" data-custom-class="heading_2">
                        <h3>Correction and Deletion Rights</h3>
                    </div>
                    <ul className="mt-2 list-disc pl-6" data-custom-class="body_text">
                        <li>Request correction of inaccurate or incomplete data</li>
                        <li>Request deletion of your personal data (subject to legal requirements)</li>
                        <li>Object to processing of your personal data</li>
                        <li>Request restriction of processing</li>
                    </ul>

                    <div className="mt-4" data-custom-class="heading_2">
                        <h3>Data Portability</h3>
                    </div>
                    <ul className="mt-2 list-disc pl-6" data-custom-class="body_text">
                        <li>Receive your personal data in a structured, commonly used format</li>
                        <li>Transfer your data to another service provider where technically feasible</li>
                    </ul>

                    <div className="mt-4" data-custom-class="heading_2">
                        <h3>Opt-Out Rights</h3>
                    </div>
                    <ul className="mt-2 list-disc pl-6" data-custom-class="body_text">
                        <li>Opt-out of marketing communications at any time</li>
                        <li>Opt-out of non-essential cookies through your browser settings</li>
                        <li>Withdraw consent where processing is based on consent</li>
                    </ul>

                    <p className="mt-3" data-custom-class="body_text">
                        To exercise these rights, please contact us at <a data-custom-class="link" href="mailto:support@oak-hr.com">support@oak-hr.com</a>. We will respond to your request within 30 days.
                    </p>

                    {/* SECTION 7 */}
                    <div className="mt-8" data-custom-class="heading_1">
                        <h2 id="children">7. CHILDREN'S PRIVACY</h2>
                    </div>
                    <p className="mt-3" data-custom-class="body_text">
                        Our Services are not intended for individuals under the age of 18. We do not knowingly collect personally identifiable information from children under 18. If you are a parent or guardian and you believe that your child has provided us with personal information, please contact us at <a data-custom-class="link" href="mailto:support@oak-hr.com">support@oak-hr.com</a>. If we become aware that we have collected personal information from a child under 18 without parental consent, we will take steps to remove that information from our servers.
                    </p>

                    {/* SECTION 8 */}
                    <div className="mt-8" data-custom-class="heading_1">
                        <h2 id="privacy-updates">8. UPDATES TO THIS PRIVACY POLICY</h2>
                    </div>
                    <p className="mt-3" data-custom-class="body_text">
                        We may update our privacy policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new privacy policy on this page and updating the "Last updated" date.
                    </p>
                    <p className="mt-3" data-custom-class="body_text">
                        These changes are effective immediately after they are posted on this page.
                    </p>

                    {/* SECTION 9 */}
                    <div className="mt-8" data-custom-class="heading_1">
                        <h2 id="contact">9. CONTACT US</h2>
                    </div>
                    <p className="mt-3" data-custom-class="body_text">
                        If you have any questions about this privacy policy, the data we hold about you, or if you would like to exercise your rights, please contact us:
                    </p>
                    <p className="mt-3" data-custom-class="body_text">
                        <strong>Konav Technologies Private Limited</strong><br />
                        <strong>D1003, Rainbow Vistas Phase 1, Moosapet</strong><br />
                        <strong>Hyderabad</strong>, <strong>Telangana</strong> <strong>500018</strong><br />
                        <strong>India</strong><br />
                        Email: <a data-custom-class="link" href="mailto:support@oak-hr.com">support@oak-hr.com</a>
                    </p>

                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
